import { render, staticRenderFns } from "./index.vue?vue&type=template&id=18d2780c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d2780c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18d2780c')) {
      api.createRecord('18d2780c', component.options)
    } else {
      api.reload('18d2780c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=18d2780c&scoped=true", function () {
      api.rerender('18d2780c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/selPlat/index.vue"
export default component.exports